import React from "react"
import { Row, Col } from "react-bootstrap"
import Content6 from "./Contents/Content6"

const Last = () => {
  return (
    <Row className="row no-gutters">
      <Col sm={1} className=" flex-column d-none d-sm-flex">
        <Row className="h-50">
          <Col
            style={{
              borderLeft: "1px solid #dee2e6!important",
              marginLeft: "30px",
            }}
          >
            &nbsp;
          </Col>
        </Row>
        <h5>
          <span
            className="badge badge-pill bg-light border"
            style={{ color: "green" }}
          >
            ...
          </span>
        </h5>
      </Col>
      <Col className="py-2">
        <Content6 />
      </Col>
    </Row>
  )
}

export default Last
